import React from 'react';
import cn from 'classnames';
import { getQueryString, useRouter } from '@framework/router';
import URL from '@/creditflowresearch/Router/urlConstants';
import { BWICS, INVENTORIES } from '@/creditflowresearch/domain/BondType';
import AssetClass from '@/creditflowresearch/domain/AssetClass';
import { getFormatUrl } from '@/creditflowresearch/ui/common/helpers';
import metaTags from '@/creditflowresearch/ui/common/metaTagsConstants';
import BwicCountLabel from '@/creditflowresearch/ui/components/bonds/common/BondTables/Bwic/BwicCountLabelContainer';
import InventoryCountLabel from '@/creditflowresearch/ui/components/bonds/common/BondTables/Inventory/InventoryCountLabelContainer';
import { TabLink as NavLink } from '@framework/router/Next/Link';
import { useMetaTagsContext } from '@/creditflowresearch/application/MetaTags/MetaTagsContext';
import { useBondsAssetClassesContext } from '@/creditflowresearch/application/Bonds/BondsAssetClassesContext';

import styles from './bondTypes.module.scss';
import tabsStyles from '@creditflowresearch/uilib/styles/legacyTabs.module.scss';

interface IBondTypesProps {
  baseUrl?: string,
  assetClass?: string,
}

interface ITabParams {
  title: string,
  description: string,
}

const BondTypes = ({ baseUrl = '', assetClass = '' } : IBondTypesProps) => {
  const { assetsClasses } = useBondsAssetClassesContext();
  const { query } : any = useRouter();
  const { assetClass: queryAssetClass, bondType, ...rest } = query;
  const search = getQueryString(rest);
  const { setMetaTags } = useMetaTagsContext();

  const onTabChange = (tabName: string) => {
    const assetType = AssetClass.getByAbbreviation(assetsClasses, assetClass);
    const tabData: ITabParams = metaTags.getBwicsInventory(tabName, assetType?.abbreviation);

    setMetaTags(tabData);
  };

  return (
    <>
      <NavLink
        to={ getFormatUrl(`${ baseUrl }${ URL.BONDS_BWICS }-${ assetClass }?${ search }`) }
        className={ cn(styles.bondTab, tabsStyles.tab) }
        activeClassName={ tabsStyles.isTabActive }
        onClick={ () => onTabChange(BWICS) }
        dataTest="bwicsTab"
      >
        <span>BWICS</span>
        <BwicCountLabel className={ tabsStyles.tabCountLabel } />
      </NavLink>
      <NavLink
        to={ getFormatUrl(`${ baseUrl }${ URL.BONDS_INVENTORIES }-${ assetClass }?${ search }`) }
        className={ cn(styles.bondTab, tabsStyles.tab) }
        activeClassName={ tabsStyles.isTabActive }
        onClick={ () => onTabChange(INVENTORIES) }
        dataTest="inventoriesTab"
      >
        <span>Inventory</span>
        <InventoryCountLabel className={ tabsStyles.tabCountLabel } />
      </NavLink>
    </>
  );
};

export default BondTypes;
